import { gql } from '@apollo/client'

// Where a new account came from (e.g. a landing page CTA). Stored on the click and sent to the API
// once, right after the account is created, so it ends up on the user in activity_events
// (event_type 'signup_attributed'). Kept separate from the person-to-person `ref` in lib/sharing.ts.
const KEY = 'culineer_signup_attribution'
const TTL_MS = 30 * 24 * 60 * 60 * 1000 // 30 days, same as the referral ref

export type SignupAttribution = {
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_content?: string
}

export function storeSignupAttribution(attribution: SignupAttribution): void {
  if (typeof window === 'undefined') return
  localStorage.setItem(KEY, JSON.stringify({ attribution, expires: Date.now() + TTL_MS }))
}

export function getStoredSignupAttribution(): SignupAttribution | null {
  if (typeof window === 'undefined') return null
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const entry = JSON.parse(raw)
    if (Date.now() > entry.expires) {
      localStorage.removeItem(KEY)
      return null
    }
    return entry.attribution as SignupAttribution
  } catch {
    return null
  }
}

export function clearStoredSignupAttribution(): void {
  if (typeof window === 'undefined') return
  localStorage.removeItem(KEY)
}

export const TRACK_SIGNUP_ATTRIBUTION = gql`
  mutation TrackSignupAttribution($input: TrackEventInput!) {
    trackEvent(input: $input)
  }
`
